import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_ODOO_API_URL || 'https://erp.intrare.app'
const API_KEY = process.env.VUE_APP_TICKETS_API_KEY || 'intrare_PpDmhOSqc8fgDcFFEPVfKIK6KH7PWo26lMd4C-VlI04'

class TicketsService {
  constructor() {
    this.apiUrl = `${API_BASE_URL}/api`
  }

  getAuthHeaders() {
    return {
      'X-API-Key': API_KEY,
      'Content-Type': 'application/json'
    }
  }

  async getAreas() {
    try {
      const response = await axios.get(
        `${this.apiUrl}/areas`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo áreas:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async getTicketsByEmail(email, limit = 50) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/tickets?email=${encodeURIComponent(email)}&limit=${limit}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo tickets:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async getTicketById(ticketId) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/ticket/${ticketId}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo ticket:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async createTicket(ticketData) {
    const response = await axios.post(
      `${this.apiUrl}/tickets`,
      ticketData,
      { headers: this.getAuthHeaders() }
    )
    return {
      success: true,
      data: response.data.data
    }
  }

  async respondQuote(ticketId, payload) {
    try {
      const response = await axios.post(
        `${this.apiUrl}/ticket/${ticketId}/respond-quote`,
        payload,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error respondiendo cotización:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async updateTicketInvoice(ticketId, payload) {
    try {
      const response = await axios.post(
        `${this.apiUrl}/ticket/${ticketId}/invoice`,
        payload,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error guardando información fiscal/factura:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async getClientFiscalInfo(email) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/client/fiscal-info?email=${encodeURIComponent(email)}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo datos fiscales del cliente:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }
}

export const ticketsService = new TicketsService()

